import { render, staticRenderFns } from "./Hotkey.vue?vue&type=template&id=de33bc70&"
import script from "./Hotkey.vue?vue&type=script&lang=js&"
export * from "./Hotkey.vue?vue&type=script&lang=js&"
import style0 from "./Hotkey.vue?vue&type=style&index=0&id=de33bc70&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de33bc70')) {
      api.createRecord('de33bc70', component.options)
    } else {
      api.reload('de33bc70', component.options)
    }
    module.hot.accept("./Hotkey.vue?vue&type=template&id=de33bc70&", function () {
      api.rerender('de33bc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/base/Hotkey.vue"
export default component.exports